window.addEventListener('pageshow', () => {
  document.querySelectorAll('[data-grs-consents] input[type="checkbox"]').forEach((input) => {
    input.checked = false;
  });
});

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || event.submitter?.name !== 'checkout') return;
  const consent = Array.from(document.querySelectorAll('[data-grs-consents]')).find((area) => area.dataset.formId === form.id);
  if (!consent) return;
  event.preventDefault();
  const agreement = consent.querySelector('[data-grs-agreement]');
  if (!agreement.checked) {
    agreement.reportValidity();
    agreement.focus();
    return;
  }
  const button = event.submitter;
  const error = consent.querySelector('[role="alert"]');
  error.hidden = true;
  button.disabled = true;
  try {
    const response = await fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: {
        'GRS legal approval': 'yes',
        'GRS explicit consent': consent.querySelector('[data-grs-explicit]').checked ? 'yes' : 'no',
        'GRS commercial communications': consent.querySelector('[data-grs-marketing]').checked ? 'yes' : 'no',
        'GRS consent timestamp': new Date().toISOString(),
        'GRS legal text version': '2026-10-01',
      } }),
    });
    if (!response.ok) throw new Error('Consent could not be saved');
    const cart = await response.json();
    if (cart.attributes?.['GRS legal approval'] !== 'yes') throw new Error('Consent not confirmed');
    window.location.assign(window.routes.cart_url.replace(/cart\/?$/, 'checkout'));
  } catch {
    error.textContent = consent.dataset.error;
    error.hidden = false;
    button.disabled = false;
  }
}, true);
